import React from 'react';
import { bool, oneOfType, string } from 'prop-types';
import './ProductImage.css';


function ProductImage({ type, positionType }) {
  const themes = {
    PACKAGE_DIAMOND: 'box-package__image__diamond',
    PACKAGE_SILVER: 'box-package__image__silver',
    PACKAGE_GOLD: 'box-package__image__gold',
    PAID_AD: 'box-package__image__basic',
    PAID_RENEWAL: 'box-package__image__basic',
    FREE_RENEWAL: 'box-package__image__basic',
    PACKAGE_BRONZE: 'box-package__image__bronze',
  };
  const classImage = themes[type];

  return <div className={`box-package__image ${positionType} ${classImage}`} />;
}

ProductImage.propTypes = {
  type: string.isRequired,
  positionType: oneOfType([bool, string]),
};

ProductImage.defaultProps = {
  positionType: false,
};


export default ProductImage;
